import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useFeatureFlagSettingsStore } from '~/store/feature-flag-settings'
import appConstants from '~/libs/constants/application-constants.js'

const { nuxtBaseUrl } = appConstants

export default defineNuxtPlugin(async ({ $lendioCookies }) => {
  const route = useRoute()
  const rootStore = useRootStore()
  const userStore = useUserStore()
  const featureFlagSettingsStore = useFeatureFlagSettingsStore()
  const affiliateCustomizationStore = useAffiliateCustomizationStore()
  const _accessToken = $lendioCookies.get('accessToken')
  const _intercomHash = $lendioCookies.get('intercom_hash')
  let _token = $lendioCookies.get('token')

  if (route.query.isEmbedded === 'true' || $lendioCookies.get('isEmbedded')) {
    await rootStore.setIsEmbedded(true)

    if (route.query.token) {
      _token = route.query.token
    }

    if (route.query.borrowerId) {
      await $lendioCookies.set('borrowerId', route.query.borrowerId, { path: `${nuxtBaseUrl}/embedded`, expires: 0.5 })
    }

    const _styleId = route.query.style_id || $lendioCookies.get('style_id')
    if (_styleId) {
      await rootStore.setStyleId(_styleId)
    }
  }

  if (_token) {
    await rootStore.setAuthToken(_token)
  }

  if (_intercomHash) {
    await rootStore.setIntercomHash(_intercomHash)
  }

  if (_accessToken) {
    await userStore.setAccessToken(_accessToken)
  }

  if (route.query.affiliateCustomizationsId) {
    await $lendioCookies.set('affiliateCustomizationsId', route.query.affiliateCustomizationsId, { path: `${nuxtBaseUrl}/sba-complete/` });
  }

  await rootStore.authenticate()

  await featureFlagSettingsStore.getActiveFeatureFlagSettings()
})
